"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CardSignpostTextLabel = exports.CardSignpostTextTitle = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Typography = require("../../Typography");

var _sharedStyle = require("../../../styles/sharedStyle");

var _Card = require("./Card.style");

var CardSignpostTextTitle = (0, _styled.default)(_Typography.PageTitle)(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      cards = _ref$theme.cards;
  return _objectSpread(_objectSpread({}, (0, _sharedStyle.textHover)({
    color: colors.white,
    width: '2px'
  })), {}, {
    fontFamily: cards.fontFamily,
    padding: 0,
    '&::before': {
      content: '""'
    }
  });
});
exports.CardSignpostTextTitle = CardSignpostTextTitle;
var CardSignpostTextLabel = (0, _styled.default)(_Card.CardLabel)(function (_ref2) {
  var colors = _ref2.theme.colors;
  return {
    width: '100%',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    color: colors.white,
    h4: {
      textShadow: '0 0 3px #000000, 0 0 3px rgba(0, 0, 0, 0.6)'
    }
  };
});
exports.CardSignpostTextLabel = CardSignpostTextLabel;